export default "/assets/weight-loss.svg";